var TitleOptionTemplate =
  '<option value="{{id}}" {{#if isSelected}}selected{{/if}}>{{name}}</option>';

var TravelerView = Backbone.View.extend({
  /**
   * Internal event listeners for the view
   */
  events: {
    "change [data-traveler-gender]": "processGenderChange",
    "click [data-no-middle-name-check]": "processNoMiddleNameCheck"
  },

  settings: {
    titles: []
  },

  // The traveler identifier for the view
  travelerNumber: null,

  // Title template to use
  titleOptionTpl: null,

  // The default ages for the fake travelers
  ages: {
    ADT: 35,
    SRC: 65,
    CHD: 8,
    INF: 0
  },

  // The default last names for the fake travelers
  lastNames: [
    "White",
    "Boop",
    "Blue",
    "Black",
    "Smith",
    "Jones",
    "Green",
    "Rubble"
  ],

  /**
   * This method processes the change of the traveler gender.
   *
   * @param event
   */
  processGenderChange: function(event) {
    this.updateTitles($(event.currentTarget).val());
  },

  /**
   * This method updates the traveler titles based on the supplied gener.
   *
   * @param gender
   */
  updateTitles: function(gender) {
    var titleEl = this.$("[data-traveler-title]");
    var selectedTitle = titleEl.val();

    // remove all of the existing title options
    titleEl.empty().append(this.titleOptionTpl());

    // loop through all the titles and add the titles that match the supplied gender or is applied to both genders.
    for (var t in this.settings.titles) {
      if (
        gender == null ||
        this.settings.titles[t].applicable_gender == gender ||
        this.settings.titles[t].applicable_gender == "B"
      ) {
        var title = this.settings.titles[t];

        if (selectedTitle == this.settings.titles[t].id) {
          title.isSelected = true;
        }

        titleEl.append(this.titleOptionTpl(title));
      }
    }
  },

  /**
   * This method enables/disables the middle name input based on the status of the no middle name checkbox.
   *
   * @param event
   */
  processNoMiddleNameCheck: function(event) {
    var self = $(event.currentTarget);

    this.$("[data-traveler-middle-name]").prop(
      "disabled",
      self.is(":checked") ? true : false
    );
  },

  /**
   * This method populates fake traveler data.
   */
  populateFakeTravelers: function() {
    var today = new Date();
    var birthYear = today.getFullYear();
    var travelerType = this.$el.data("traveler-type");

    if (travelerType) {
      birthYear = today.getFullYear() - this.ages[travelerType];
    }

    this.$("[data-traveler-gender]")
      .val("F")
      .trigger("change");
    this.$("[data-traveler-title]").val("2");
    this.$("[data-traveler-first-name]")
      .val("Betty")
      .trigger("change");
    this.$("[data-traveler-last-name]")
      .val(this.lastNames[Math.floor(Math.random() * this.lastNames.length)])
      .trigger("change");

    var Calendar = this.$(
      '[data-calendar="date-of-birth-calendar-' + this.travelerNumber + '"]'
    ).component();

    Calendar.setDate("01/01/" + birthYear);
  },

  /**
   * This method initializes the view.
   *
   * @param options
   */
  initialize: function(options) {
    if (options.settings) {
      this.settings = $.extend(true, this.settings, options.settings);
    }

    this.travelerNumber = this.$el.data("travelerNumber");
    this.titleOptionTpl = options.titleOptionTpl;

    this.updateTitles(this.$("[data-traveler-gender]").val());
  }
});

var TravelerInformationView = Backbone.View.extend({
  /**
   * Internal event listeners for the view.
   */
  events: {
    "click [data-fake-travelers]": "populateFakeTravelers"
  },

  settings: {},

  /**
   * This method handles the populating of fake traveler data.
   */
  populateFakeTravelers: function() {
    _.each(this.travelerViews, function(View) {
      View.populateFakeTravelers();
    });
  },

  /**
   * This method initializes the view.
   */
  initialize: function() {
    if (this.$el.data("settings")) {
      this.settings = $.extend(true, this.settings, this.$el.data("settings"));
    }

    var self = this;

    self.travelerViews = [];

    var titleTpl = Handlebars.compile(TitleOptionTemplate);

    this.$("[data-traveler-block]").each(function() {
      var View = new TravelerView({
        el: this,
        titleOptionTpl: titleTpl,
        settings: self.settings
      });

      self.travelerViews.push(View);
    });
  }
});

module.exports = TravelerInformationView;
